// removed by extract-text-webpack-plugin
module.exports = {"static-container":"static-container__E7LF5","dark-bg":"dark-bg__BQ2UA","close-button-container":"close-button-container__2EKeN text-light","static-container-inner":"static-container-inner__3O-15","shadow":"shadow__2pymF"};


//////////////////
// WEBPACK FOOTER
// ./components/StaticContainer/StaticContainer.css
// module id = PUCB
// module chunks = 14